import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left--sprite",
  "use": "arrow-left--sprite-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"arrow-left--sprite\">\n    <g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#1e2122\" stroke-linecap=\"square\" stroke-width=\"1.2\">\n        <path d=\"M11.531 3.938L9.312 6.28 6.469 9.281M11.813 14.625L6.468 9.281\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol